import React, { FunctionComponent } from 'react'

export interface Props {
  color: string
  height: string
  width: string
}

export const CheckMark: FunctionComponent<Props> = ({
  color = '#001833',
  height = '24px',
  width = '24px',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Icon/Success</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <path
        d="M18.3,6.3 L9,15.6 L5.7,12.3 C5.3,11.9 4.7,11.9 4.3,12.3 C3.9,12.7 3.9,13.3 4.3,13.7 L8.3,17.7 C8.5,17.9 8.7,18 9,18 C9.3,18 9.5,17.9 9.7,17.7 L19.7,7.7 C20.1,7.3 20.1,6.7 19.7,6.3 C19.3,5.9 18.7,5.9 18.3,6.3 Z"
        id="path-1"
      />
    </defs>
    <g id="Icon/Success">
      <mask id="mask-2" fill="white">
        <use xlinkHref="#path-1" />
      </mask>
      <g id="Mask" fillRule="nonzero" />
      <g id="Mixin/Fill/Black" mask="url(#mask-2)" fill={color}>
        <rect id="Rectangle" x="0" y="0" width="24" height="24" />
      </g>
    </g>
  </svg>
)
